export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  EMAIL_CONFIRMATION: "/email-confirmation",
  EMAIL_CONFIRMED: "/email-confirmed",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_EMAIL_SENT: "/reset-password-sent",
  AUTHORIZE_REDIRECT: "/authorize-redirect",
  CREATE_SESSION: "/create-session",
  SESSIONS: "/sessions",
  HOME_PAGE: "/home",
};
